import React, {useContext} from 'react'
import FormTranslationContext from "context/FormTranslationContext";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import {Collapse} from "@material-ui/core";
import getObjectValue from "libs/getObjectValue";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";


function RealizationTypeData(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const updateNotice = getObjectValue('_updateNotice', formikProps.values, true);
    const {getDict} = useContext(FormTranslationContext)

    const refersTo = gVal("form.basicData.refersTo", false);
    const orderRealizationType = gVal("orderRealizationType");
    const freeChoiceOrderTypes = ["1.3.1.1-2", "1.3.2-4", "1.4.1.1-5", "1.4.1.7-14", "1.4.2-5"]
    return (<>
        <Collapse in={refersTo === "Order"}>
            <NoticeGlossaryInput
                id={gId("orderRealizationType")}
                formikProps={formikProps}
                items={getDict("ENUM.018")}
                required
                disabled={updateNotice}
            />
            <Collapse in={freeChoiceOrderTypes.includes(orderRealizationType)}>
                <NoticeTextInput
                    formikProps={formikProps}
                    id={gId("freeChoiceTenderReason")}
                    required
                />
                <NoticeTextInput
                    formikProps={formikProps}
                    id={gId("previousTenderOrAgreementId")}
                    required
                />
            </Collapse>
        </Collapse>
        <Collapse in={refersTo === "FrameworkAgreement"}>
            <NoticeGlossaryInput
                id={gId("frameworkRealizationType")}
                formikProps={formikProps}
                items={getDict("ENUM.019A")}
                required
                disabled={updateNotice}
            />
        </Collapse>
    </>)
}

RealizationTypeData.propTypes = {};

export default RealizationTypeData;
